import React from 'react';
export function PainSection() {
  return <section className="bg-[#F5F6F7] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-109">
      <div className="max-w-2xl mx-auto" data-id="element-110">
        <h2 className="text-xl md:text-2xl font-black text-[#1F3D2B] mb-2 text-center leading-tight" data-id="element-111">
          Si enseñás gestión agropecuaria o legislación rural… esto te pasa.
        </h2>

        <div className="bg-white border-2 border-gray-200 rounded-xl p-3 md:p-4 shadow-lg" data-id="element-112">
          <p className="text-sm md:text-base text-gray-700 font-medium mb-2 leading-relaxed text-center" data-id="element-113">
            Terminás una clase… y ya tenés que pensar la siguiente. Buscás
            información en distintos lados. Intentás entender leyes, contratos,
            normativas… y después tenés que bajarlo a clase. Intentás organizar
            todo… pero nunca termina de cerrar.
          </p>

          <div className="bg-red-50 border-l-4 border-red-500 p-2 mb-2" data-id="element-114">
            <p className="text-base md:text-lg font-black text-red-600 text-center" data-id="element-115">
              Y al final… 👉 Terminás improvisando.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 mb-2" data-id="element-116">
            {['No tenés material estructurado', 'Todo lo tenés que adaptar vos', 'Perdés horas todas las semanas', 'No sabés cómo evaluar temas complejos'].map((item, i) => <div key={i} className="flex items-center gap-1.5 bg-[#F5F6F7] p-2 rounded-lg border border-gray-200" data-id="element-117">
                <span className="text-red-500 text-sm flex-shrink-0" data-id="element-118">❌</span>
                <span className="text-gray-800 font-bold text-xs md:text-sm" data-id="element-119">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-sm text-gray-700 font-medium mb-2 text-center" data-id="element-120">
            Y eso no solo te consume tiempo…
          </p>

          <div className="bg-[#1F3D2B] rounded-lg p-2 text-center mb-2" data-id="element-121">
            <p className="text-[#D4A843] font-black text-sm md:text-base" data-id="element-122">
              👉 Te hace enseñar por debajo de tu nivel.
            </p>
          </div>

          <p className="text-lg md:text-xl font-black text-[#1F3D2B] text-center" data-id="element-123">
            ¿Cuántas clases más vas a seguir improvisando?
          </p>
        </div>
      </div>
    </section>;
}